import { clsx, type ClassValue } from 'clsx'

/**
 * Utility function to merge class names
 * Wrapper around clsx for consistent class name handling
 *
 * @example
 * cn('base-class', condition && 'conditional-class', className)
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}
